import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Slide } from '../components/SlideComponents/slide.types';
import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';
import { ById, PromptSingleTestCaseResult } from '../services/backendService/types';

const useRunTestcases = () => {
  const { mutate: runTestcases, isLoading: isRunningTestcases, error } = useMutation(
    async ({
      testcaseIds,
      presentationId,
      useSlidesAsSampleLesson = false,
    }: {
      testcaseIds: string[];
      presentationId: string;
      useSlidesAsSampleLesson?: boolean;
      onSuccessFunction?: (
        results: ById<{
          slides: Slide[];
          allTestcasePromptOutputs?: PromptSingleTestCaseResult;
          lessonAttachments?: LessonAttachment[];
          error?: string;
        }>,
      ) => void;
      onErrorFunction?: (props: {
        message: string;
        status?: number;
        rawResponse: string;
      }) => void;
    }) => {
      if (!presentationId) return Promise.resolve(undefined);
      return await BackendService.instance.ai.runTestcases({
        testcaseIds,
        presentationId,
        useSlidesAsSampleLesson,
      });
    },
    {
      onSuccess: (data, { onSuccessFunction }) => {
        if (data) {
          if (onSuccessFunction) {
            onSuccessFunction(data);
          }
        }
      },
      onError: (error: AxiosError, { onErrorFunction }) => {
        if (onErrorFunction) {
          onErrorFunction({
            message: error.response?.data.error.message,
            status: error.response?.status,
            rawResponse: JSON.stringify(error),
          });
        }
      },
    },
  );
  return { runTestcases, isRunningTestcases, error: JSON.stringify(error) };
};
export default useRunTestcases;
